import {
	API_ERROR,
	QUALITY,
	QUALITY_LIST_SUCCESSFUL,
	QUALITY_ADD,
	QUALITY_ADD_SUCCESSFUL,
	QUALITY_EDIT,
	QUALITY_EDIT_SUCCESSFUL,
	QUALITY_DELETE,
	QUALITY_SETROWDATA,
	MODEL_OPEN,
	MODEL_CLOSE,
	SET_PARAMS,
} from "./actionTypes";

const initialState = {
	error: "Sorry! No Data Found.",
	message: null,
	loading: false,
	qualitylist: [],
	count: 0,
	model: false,
	error_msg: null,
	rowdata: {},
	params: {
		no_of_pages: 0,
		page_size: 10,
		page: 1,
		search: "",
		currentSort: "code",
		sortOrder: "-",
	},
};

const quality = (state = initialState, action) => {
	switch (action.type) {
		case SET_PARAMS:
			state = {
				...state,
				params: action.payload,
			};
			break;
		case QUALITY:
			state = {
				...state,
				loading: true,
			};
			break;
		case QUALITY_LIST_SUCCESSFUL:
			var noofpages = Math.ceil(
				action.payload.response.count / state.params.page_size
			);
			state = {
				...state,
				qualitylist: action.payload.response.results || [],
				count: action.payload.response.count || 0,
				loading: false,
				params: {
					...state.params,
					no_of_pages: noofpages,
				},
			};
			break;
		case QUALITY_ADD:
			state = {
				...state,
				loading: false,
			};
			break;
		case QUALITY_ADD_SUCCESSFUL:
			state = {
				...state,
				message: action.payload,
				loading: false,
				model: false,
				rowdata: { Id: 0 },
			};
			break;
		case QUALITY_EDIT:
			state = {
				...state,
				model: true,
				rowdata: action.payload,
			};
			break;
		case QUALITY_EDIT_SUCCESSFUL:
			state = {
				...state,
				loading: false,
				rowdata: { Id: 0 },
			};
			break;
		case QUALITY_DELETE:
			state = {
				...state,
				loading: false,
			};
			break;
		case QUALITY_SETROWDATA:
			state = {
				...state,
				rowdata: action.payload,
				// model: true,
			};
			break;
		case MODEL_OPEN:
			state = {
				...state,
				model: true,
			};
			break;
		case MODEL_CLOSE:
			state = {
				...state,
				model: false,
				rowdata: { id: 0 },
			};
			break;
		case API_ERROR:
			state = {
				...state,
				loading: false,
				error_msg: action.payload,
			};
			break;

		default:
			state = { ...state };
			break;
	}
	return state;
};

export default quality;
